export const blockIconsCommunicationPersonSearch = (
	<span className='material-symbols-outlined'>person_search</span>
);
